import React, { PureComponent } from 'react';
import { Button, ButtonToolbar } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Blogs } from '../../../../services/Blogs';
import { connect } from 'react-redux';
import { initCurrentBlog, fetchBlogs } from '../../../../redux/actions/blogsActions';
import { fetchDrafts } from '../../../../redux/actions/draftsActions';
import { fetchPosts } from '../../../../redux/actions/postsActions';
import withErrorNotification from '../../../../hof/withErrorNotification';
import Notifications from '../../../../hof/notifications';
import renderSubdomainInput from '../../../../shared/components/form/SubdomainInput';
import validateCreateForm from '../validators/validateCreateForm';
import config from '../../../../config';
import renderImageSelector from '../../../../shared/components/form/ImageSelector';
import {withTranslation} from "react-i18next";
import {translate} from "../../../../translations/i18n";

const themes = [
  { image: `${process.env.PUBLIC_URL}/img/themes/clean-blog.png`, value: 'clean-blog', name: "Clean blog" },
  { image: `${process.env.PUBLIC_URL}/img/themes/magazine.png`, value: 'magazine', name: "Magazine" },
  { image: `${process.env.PUBLIC_URL}/img/themes/stellar.png`, value: 'stellar', name: "Stellar" },
  { image: `${process.env.PUBLIC_URL}/img/themes/strata.png`, value: 'strata', name: "Strata" },
  { image: `${process.env.PUBLIC_URL}/img/themes/editorial.png`, value: 'editorial', name: "Editorial" }
];

class WizardFormCreate extends PureComponent {
  static propTypes = {
    nextPage: PropTypes.func.isRequired,
  };

  state = {
    selectedValue: null
  }


  createBlog = async (values) => {

    validateCreateForm(values);

    await withErrorNotification(async () => {
      const { title, slogan, domain, theme } = values;
      const blog = await Blogs.createNewBlog(domain, title, slogan, theme);
      this.props.initCurrentBlog(blog._id);
      this.props.fetchBlogs();
      this.props.fetchDrafts(blog._id);
      this.props.fetchPosts(blog._id);
      Notifications.showNotification(translate('create.notifications.created.title'), translate('create.notifications.created.body'), 'success');
      this.props.nextPage();
    })

  }

  render() {

    const { t } = this.props;

    return (
      <form className="form form--horizontal wizard__form" onSubmit={this.props.handleSubmit(this.createBlog)} >
        <h3 className="wizard__title">{t('create.wizard.create.fill_in_blog_details')}</h3>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('settings.form_address.label')}</span>
          <div className="form__form-group-field">
            <Field
              name='domain'
              component={renderSubdomainInput}
              domains={config.DOMAINS}
            />
          </div>
        </div>

        <div className="form__form-group">
          <span className="form__form-group-label">{t('settings.form_title.label')}</span>
          <div className="form__form-group-field">
            <Field
              required={true}
              name="title"
              component="input"
              type="text"
              placeholder="My new blog"
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('settings.form_slogan.label')}</span>
          <div className="form__form-group-field">
            <Field
              name="slogan"
              component="input"
              type="test"
              placeholder="This rocks!"
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('settings.theme.title')}</span>
          <div className="form__form-group-field">
            <Field name="theme" component={renderImageSelector} options={themes}/> 
          </div>
        </div>

        <ButtonToolbar className="form__button-toolbar wizard__toolbar">
          <Button color="primary" className="next" >{t('create.wizard.create.button_create')}</Button>
          {this.props.error && <p>Error</p>}
        </ButtonToolbar>
      </form>
    );
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    initCurrentBlog: (blogId) => dispatch(initCurrentBlog(blogId)),
    fetchBlogs: () => dispatch(fetchBlogs()),
    fetchDrafts: (blogId) => dispatch(fetchDrafts(blogId)),
    fetchPosts: (blogId) => dispatch(fetchPosts(blogId)),
  }
}

WizardFormCreate = connect(
  null,
  mapDispatchToProps
)(WizardFormCreate);

export default reduxForm({
  form: 'create', //                 <------ same form name
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(withTranslation('dashboard')(WizardFormCreate));
